import * as React from 'react';
import * as styles from './style.css';

export const MobileWidget = ({ children }: React.PropsWithChildren) => {
  return (
    <div data-testid="offers-layouts" className={styles['container']}>
      {children}
    </div>
  );
};
